import { NgIf } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { IconName } from '@sc/data-access-assets';
import { IconComponent } from '../icon';
import { SpinnerComponent } from '../spinner';

@Component({
  selector: 'sc-button',
  styleUrls: ['./button.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [NgIf, IconComponent, SpinnerComponent],
  template: `
    <button
      *ngIf="!isLinkButton && !linkButtonLabel"
      [type]="type"
      [class]="[buttonType, 'sc-design-button']"
      [class.auto-width]="autoWidth"
      [class.icon-only]="iconOnly"
      [disabled]="disabled"
      [attr.title]="title"
      [attr.aria-label]="ariaLabel"
      [attr.aria-labelledby]="ariaLabelledBy"
      [attr.role]="ariaRole"
      [attr.aria-disabled]="disabled ? true : undefined"
      tabindex="0"
    >
      <span class="btn-wrapper">
        <sc-icon
          *ngIf="leftIcon && !loading"
          [name]="leftIcon"
          [specificName]="leftIconSpecificName"
        ></sc-icon>
        <span
          class="button-content"
          [class.left-icon]="!iconOnly && leftIcon"
          [class.right-icon]="!iconOnly && rightIcon"
        >
          <ng-content *ngIf="!loading && !iconOnly"></ng-content>
        </span>
        <sc-icon
          *ngIf="rightIcon && !loading"
          [name]="rightIcon"
          [specificName]="rightIconSpecificName"
        ></sc-icon>
        <sc-spinner *ngIf="loading" [size]="40"></sc-spinner>
      </span>
    </button>
    <a
      *ngIf="isLinkButton && linkButtonLabel"
      [class]="[buttonType, 'sc-design-button', 'linkButton']"
      tabindex="0"
      [title]="linkButtonTitle"
      >{{ linkButtonLabel }}</a
    >
  `,
})
export class ButtonComponent {
  @Input() type: HTMLButtonElement['type'] = 'button';
  @Input() disabled = false;
  @Input() buttonType:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'error'
    | 'white'
    | 'mainWhite'
    | 'errorWhite'
    | 'errorDark'
    | 'grey'
    | 'validation'
    | 'noShow' = 'primary';
  @Input() autoWidth = false;
  @Input() leftIcon: IconName;
  @Input() leftIconSpecificName: string = undefined;
  @Input() rightIcon: IconName;
  @Input() rightIconSpecificName: string = undefined;
  @Input() iconOnly: boolean;
  @Input() loading = false;
  @Input() title: string;
  @Input() ariaLabel: string;
  @Input() ariaLabelledBy: string;
  @Input() ariaRole: string;
  @Input() isLinkButton = false;
  @Input() linkButtonLabel: string;
  @Input() linkButtonTitle: string;
}
